import React from 'react';
import Helmet from 'react-helmet';
export function GtmDataLayerSetup(_ref) {
  var contentType = _ref.contentType,
      templateType = _ref.templateType;
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", null, "\n\t\t\t\t \twindow.dataLayer = window.dataLayer || [];\n\t\t\t\t\twindow.dataLayer.push({\n\t\t\t\t\t\tcontentType: \"".concat(contentType, "\",\n\t\t\t\t\t\ttemplateType: \"").concat(templateType, "\",\n\t\t\t\t\t\tURL: window.location.href,\n\t\t\t\t\t})\n\t\t\t\t")));
}